import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import LicenseList from './pages/LicenseList';
import LicenseEdit from './pages/LicenseEdit';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhCN}>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/user/dashboard" element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/licenses" element={
                <ProtectedRoute role="admin">
                  <LicenseList />
                </ProtectedRoute>
              } />
              <Route path="/admin/licenses/new" element={
                <ProtectedRoute role="admin">
                  <LicenseEdit mode="create" />
                </ProtectedRoute>
              } />
              <Route path="/admin/licenses/edit/:id" element={
                <ProtectedRoute role="admin">
                  <LicenseEdit mode="edit" />
                </ProtectedRoute>
              } />
              <Route path="/" element={<Login />} />
            </Routes>
          </div>
        </Router>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
